export const GET_DATA_FILTERS_FILES_UPLOADED_FILES = 'GET_DATA_FILTERS_FILES_UPLOADED_FILES'
export const GET_DATA_FILES_UPLOADED_FILES = 'GET_DATA_FILES_UPLOADED_FILES'
export const GET_DATA_FILES_UPLOADED_FILES_CLONE = 'GET_DATA_FILES_UPLOADED_FILES_CLONE'